import React, { useState } from 'react';
import { useLanguage } from './useLang';

const SwitchLanguage = () => {
    const { lang, toggleLanguage, t } = useLanguage(); // Получаем функцию переключения и текущий язык

    return (
        <>
            <div className="language-switch">
                <button onClick={toggleLanguage}>
                    {lang === 'en' ? 'RU' : 'EN'} {/* Отображаем текущий язык */}
                </button>
            </div>
        </>
    );
}

export default SwitchLanguage;